// src/db/db.js
import Dexie from 'dexie';

export const dbs = new Dexie('PlatterlyDB');

// Increment to version 2 for the schema change
dbs.version(2).stores({
  // Indexed fields (like companyCode, orderStatus) allow fast querying
  companymenu: 'id, itemCode, companyCode', 
  orders: 'orderId, orderNo, tableId, companyCode, orderStatus',
  syncMetadata: 'id' 
});